import { cn, Skeleton } from '@wellesley/ui'

type TSkeletonList = {
  count?: number
  className?: string
}

const UsersListSkeleton = ({ count = 15, className }: TSkeletonList) => (
  <div
    data-testid="list-loader"
    className={cn(
      'gap-m ml-auto mr-auto flex max-w-[560px] flex-col',
      className,
    )}
  >
    {Array.from({ length: count }).map((_, index: number) => (
      <div className={'flex gap-2.5'} key={index}>
        <Skeleton className={'size-m rounded-full'} />
        <div className="flex flex-1 flex-col gap-2.5">
          <Skeleton className={'h-xxxs w-full'} />
          <Skeleton className={'h-xxxs w-[116px]'} />
        </div>
      </div>
    ))}
  </div>
)

export default UsersListSkeleton
